import { Box, Button, CircularProgress, DialogActions, Divider } from '@material-ui/core';
import { Dispatch } from '@reduxjs/toolkit';
import CustomDatepicker from 'components/Form/Input/CustomDatepicker';
import { ButtonVariantEnum } from 'enums/buttonVariant';
import { DialogVariantEnum } from 'enums/dialogVariant';
import React, { Component, Fragment } from 'react';
import { Field, Form } from 'react-final-form';
import { withTranslation, WithTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { AppDispatch, AppState } from 'store';
import { dialogClose } from 'store/dialog/dialog.actions';
import { DialogOpenPayloadJobs } from 'store/dialog/dialog.interface';
import { changeDueDateJob, changeDueDateProject } from 'store/projects/projects.actions';
import { getJobActionSpinnerSelector } from 'store/spinner/spinner.selectors';
import { requiredDate } from 'utils/customValidators';
import { CustomDialogButtonContainer } from '../CustomDialog.styled';

interface IProps {
  onClose: ((response: ButtonVariantEnum) => void) | undefined;
  jobs: DialogOpenPayloadJobs;
  variant: DialogVariantEnum;
  projectId: string;
}

interface IDispatchProps {
  changeDueDateJob: (payload: { jobId: string; dueDate: Date }) => AppDispatch;
  changeDueDateProject: (payload: { projectId: string; dueDate: Date }) => AppDispatch;
  dialogClose: () => AppDispatch;
}

interface IStateProps {
  jobActionSpinner: boolean;
}

type PropType = IProps & WithTranslation & IDispatchProps & IStateProps;

class ChangeDueDate extends Component<PropType> {
  private handleClose = () => (): void => {
    const { dialogClose } = this.props;
    dialogClose();
  };

  handleSubmit = ({ dueDate }: { dueDate: Date }): void => {
    const { changeDueDateProject, changeDueDateJob, variant, jobs, projectId } = this.props;

    switch (variant) {
      case DialogVariantEnum.CHANGE_DUE_DATE_JOB: {
        changeDueDateJob({ jobId: jobs[0].id, dueDate });
        break;
      }
      case DialogVariantEnum.CHANGE_DUE_DATE_PROJECT: {
        changeDueDateProject({ projectId, dueDate });
        break;
      }
    }
  };

  render(): JSX.Element {
    const { jobActionSpinner, t } = this.props;

    return (
      <Form
        onSubmit={this.handleSubmit}
        subscription={{
          pristine: true,
          submitting: true,
          errors: true,
        }}
        render={({ handleSubmit }): JSX.Element => (
          <form onSubmit={handleSubmit}>
            <Fragment>
              <Box width="300px" padding="0 20px" paddingBottom="20px">
                <Field
                  name="dueDate"
                  component={CustomDatepicker}
                  validate={requiredDate}
                  placeholder={t('common.selectPlaceholder')}
                  width="100%"
                />
              </Box>
              <Divider />
              <DialogActions>
                <CustomDialogButtonContainer>
                  <Button variant="contained" color="secondary" type="submit" disabled={jobActionSpinner}>
                    {(jobActionSpinner && <CircularProgress size="24px" color="secondary" />) || t('common.save')}
                  </Button>
                  <Button variant="outlined" onClick={this.handleClose()} disabled={jobActionSpinner}>
                    {t('common.cancel')}
                  </Button>
                </CustomDialogButtonContainer>
              </DialogActions>
            </Fragment>
          </form>
        )}
      />
    );
  }
}

const mapStateToProps = (state: AppState): IStateProps => ({
  jobActionSpinner: getJobActionSpinnerSelector(state),
});

const mapDispatchToProps = (dispatch: Dispatch<AppDispatch>): IDispatchProps => ({
  changeDueDateJob: (payload: { jobId: string; dueDate: Date }): AppDispatch => dispatch(changeDueDateJob(payload)),
  changeDueDateProject: (payload: { projectId: string; dueDate: Date }): AppDispatch =>
    dispatch(changeDueDateProject(payload)),
  dialogClose: (): AppDispatch => dispatch(dialogClose()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ChangeDueDate));
